module.exports = __webpack_public_path__ + "static/media/detail_0045_f.1ff5110a.jpg";